import { LinkBase } from '@sleepstation/components-base'
import { LinkButton, SubsectionTitle } from '@sleepstation/components'
import { HLayout, VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_ALIGN, LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import { marginTop, padding, mq } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { classStartsWith } from '@sleepstation/style-mixins'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

// TODO: Add border width with rhythm;
const Layout = styled(VLayout).attrs(({ id }) => ({
  spacing: LAYOUT_SPACING.MEDIUM,
  'data-cy': `${id}-banner`,
}))`
  ${padding([[1, 0, 0, 0]])}
  position: relative;
`

const Wrapper = styled(LinkBase).attrs(() => ({
  'data-cy': `banner-next-link-wrapper`,
}))`
  ${marginTop(1)}
  text-decoration: none;

  > ${classStartsWith(`LinkButton__`)} {
    width: 100%;

    ${mq(`smallUp`)} {
      max-width: 300px;
    }
  }
`

const Header = styled(HLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
  align: LAYOUT_ALIGN.CENTER,
  'data-cy': `hub-banner-title`,
})`
  > *:last-child {
    flex-grow: 2;
  }
`

const Body = styled.div`
  font-size: 18px;
  max-width: 640px;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HeaderAttachedBannerContent = ({
  id,
  title,
  bodyAst,
  link,
  shouldShowLink,
}) => (
  <Layout id={id}>
    <Header>
      <SubsectionTitle>{title}</SubsectionTitle>
    </Header>
    <Body>
      <CopyRenderer htmlAst={bodyAst} isCompact />
    </Body>
    {shouldShowLink && (
      <Wrapper href={link.url} data-cy="banner-next-link-wrapper">
        <LinkButton as="div" size={SIZE.SMALL} data-cy="banner-next-link">
          {link.label}
        </LinkButton>
      </Wrapper>
    )}
  </Layout>
)

HeaderAttachedBannerContent.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bodyAst: PropTypes.object.isRequired,
  link: PropTypes.object,
  shouldShowLink: PropTypes.bool,
}

HeaderAttachedBannerContent.defaultProps = {
  shouldShowLink: true,
  link: null,
}

export default HeaderAttachedBannerContent
